import React from 'react';
import { IMAGES } from '../data/content';
import { TransformCta } from './CtaButton';
const paragraphs = ['Durante años observó el mismo problema una y otra vez: profesionales con una excelente formación, con mucho conocimiento, pero sin una ruta clara para actuar cuando un paciente con infertilidad masculina se sentaba frente a ellos.', 'No porque les faltara capacidad, sino porque la información estaba distribuida entre guías clínicas, artículos científicos y libros extensos, difíciles de consultar durante una consulta.', 'Por eso creó Ruta Fertilidad Masculina. No como otro manual para estudiar, sino como un sistema clínico diseñado para transformar información compleja en decisiones prácticas y aplicables.'];
export function About() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-17" data-mp="3hkhewl2fjez8">
      <div className="mx-auto max-w-4xl" data-id="element-18" data-mp="3mjkie12rhd53">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-900 sm:text-4xl" data-id="element-19" data-mp="3rgkna8nvk9um">
          🩺 Sobre la Dra. Karito
        </h2>

        <div className="mt-8 grid gap-6 md:grid-cols-[minmax(0,300px)_1fr] md:items-start md:gap-8" data-id="element-20" data-mp="2lsili43qt9t0">
          <div className="mx-auto w-full max-w-[280px] md:max-w-none" data-id="element-21" data-mp="2gqta2nclyu4e">
            <img src={IMAGES.karito} alt="Retrato de la Dra. Karito, creadora de Ruta Fertilidad Masculina" className="w-full rounded-3xl border-4 border-white object-cover shadow-card" loading="lazy" data-id="element-22" data-mp="2crbzxgm8l8sw" />
            <p className="mt-3 text-center font-display text-lg font-bold text-navy-900" data-id="element-23" data-mp="30flj0as2figc">
              Dra. Karito
            </p>
            <p className="text-center text-[12px] font-semibold uppercase tracking-wide text-violet-700 sm:text-[13px]" data-id="element-24" data-mp="2vo3qmb43yq6z">
              Creadora de la Ruta Fertilidad Masculina
            </p>
          </div>

          <div className="space-y-3.5" data-id="element-25" data-mp="3o790y37cnj6h">
            {paragraphs.map(p => <p key={p} className="text-[14px] leading-relaxed text-navy-800/80 sm:text-[16px]" data-id="element-26" data-mp="3jdy2apcoy8pn">
                {p}
              </p>)}
            <p className="rounded-2xl border border-violet-200 bg-violet-50 p-4 text-[14px] font-semibold leading-relaxed text-navy-900 sm:text-[16px]" data-id="element-27" data-mp="b3vjda016rvm">
              El objetivo nunca fue que memorices más contenido. El objetivo es que cada vez que un
              paciente llegue a tu consulta, sepas exactamente cuál es el siguiente paso.
            </p>
          </div>
        </div>

        <TransformCta headline="Lleva su método clínico a tu próxima consulta." data-id="element-28" data-mp="3ok37j5s1xba6" />
      </div>
    </section>;
}